import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Home from './pages/Home';
import Checkout from './pages/Checkout';
import Payment from './pages/Payment';
import TransactionTracking from './pages/TransactionTracking';
import Settings from './pages/Settings';
import BackToApp from './pages/BackToApp';
import MobileBackBar from './components/MobileBackBar';

const HIDDEN_PATHS = new Set(['/', '/home']);

// Reserve top space on mobile only when the back bar actually renders.
function AppShell({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const showBackBar = !HIDDEN_PATHS.has(location.pathname);
  return (
    <div className={showBackBar ? 'pt-11 md:pt-0' : ''}>
      <MobileBackBar />
      {children}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppShell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/checkout/:gameId" element={<Checkout />} />
            <Route path="/payment/:orderId" element={<Payment />} />
            <Route path="/transactions" element={<TransactionTracking />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/BackToApp" element={<BackToApp />} />
          </Routes>
        </AppShell>
      </Router>
    </AuthProvider>
  );
}

export default App;
